var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"mb-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":require("@/assets/images/Prochainement.png")}})])])}]

export { render, staticRenderFns }